import React from 'react';
import { Button, Form, Input } from 'antd';
import type { FormInstance } from 'antd/es/form';
import { useIntl } from 'react-intl';

import IntlMessages from '@src/util/IntlMessages';

import type { MarkingPortalFormValues } from '../hooks/useMarkingPortal';
import styles from '../styles.module.less';

interface MarkingPortalIdentificationFormProps {
  form: FormInstance<MarkingPortalFormValues>;
  isSubmitting: boolean;
  isSendingPin: boolean;
  onIdentify: (values: MarkingPortalFormValues) => void;
  onSendPin: () => void;
}

export const MarkingPortalIdentificationForm: React.FC<MarkingPortalIdentificationFormProps> = ({
  form,
  isSubmitting,
  isSendingPin,
  onIdentify,
  onSendPin,
}) => {
  const intl = useIntl();

  return (
  <div className={styles.formCard}>
    <h2 className={styles.welcomeTitle}>
      <IntlMessages id="markingPortal.welcome" />
    </h2>
    <p className={styles.welcomeSubtitle}>
      <IntlMessages id="markingPortal.identify.subtitle" />
    </p>

    <Form<MarkingPortalFormValues>
      form={form}
      layout="vertical"
      requiredMark={false}
      onFinish={onIdentify}
      className={styles.form}
    >
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: <IntlMessages id="markingPortal.identify.email.required" />,
          },
        ]}
      >
        <Input
          size="large"
          type="email"
          placeholder={intl.formatMessage({ id: 'markingPortal.identify.email.placeholder' })}
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: <IntlMessages id="markingPortal.identify.password.required" />,
          },
        ]}
      >
        <Input.Password
          size="large"
          placeholder={intl.formatMessage({ id: 'markingPortal.identify.password.placeholder' })}
        />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        block
        size="large"
        loading={isSubmitting}
        className={styles.submitButton}
      >
        <IntlMessages id="markingPortal.identify.submit" />
      </Button>
    </Form>

    <div className={styles.sendPinRow}>
      <Button
        type="link"
        className={styles.linkButton}
        loading={isSendingPin}
        disabled={isSubmitting}
        onClick={onSendPin}
      >
        <IntlMessages id="markingPortal.identify.sendPin" />
      </Button>
    </div>
  </div>
  );
};
